"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardRowNumericEditor_1 = require("../../../../../../../../shared/components/editors/CardRowNumericEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardEditorContainer_1 = require("../../../../../../../../shared/components/containers/CardEditorContainer");
var EventBindingOnTimerCfgEditor = /** @class */ (function (_super) {
    __extends(EventBindingOnTimerCfgEditor, _super);
    function EventBindingOnTimerCfgEditor(props) {
        return _super.call(this, props) || this;
    }
    EventBindingOnTimerCfgEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            this.props.data.LoadData(this.props.record.key, function () {
                _this.setState({
                    is_only_create_on_exact_day_of_month_number: _this.props.data.DATA.is_only_create_on_exact_day_of_month_number,
                    only_create_on_exact_day_of_month_number: _this.props.data.DATA.only_create_on_exact_day_of_month_number,
                    is_only_create_on_exact_day_of_week_number: _this.props.data.DATA.is_only_create_on_exact_day_of_week_number,
                    only_create_on_exact_day_of_week_number: _this.props.data.DATA.only_create_on_exact_day_of_week_number,
                    create_on_exact_hour_of_day_number: _this.props.data.DATA.create_on_exact_hour_of_day_number,
                    is_only_create_on_exact_hour_of_day_number: _this.props.data.DATA.is_only_create_on_exact_hour_of_day_number,
                    check_cashback_timeout_minutes: _this.props.data.DATA.check_cashback_timeout_minutes
                });
            });
        }
        this.setState({
            is_only_create_on_exact_day_of_month_number: false,
            only_create_on_exact_day_of_month_number: 1,
            is_only_create_on_exact_day_of_week_number: false,
            only_create_on_exact_day_of_week_number: 1,
            is_only_create_on_exact_hour_of_day_number: false,
            create_on_exact_hour_of_day_number: 1,
            check_cashback_timeout_minutes: 1
        });
        //
        //this.props.state.setExtBreadCrumbPath(["Настройка обработчика события <таймер>"]);
        this.props.state.setExtBreadCrumbPath(["\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u0430 - [" + this.props.record.title + "]"]);
        this.doReSetRules();
    };
    EventBindingOnTimerCfgEditor.prototype.doReSetRules = function () {
        this.setState({
            only_create_on_exact_day_of_month_number_rules: { isError: false },
            only_create_on_exact_day_of_week_number_rules: { isError: false },
            create_on_exact_hour_of_day_number_rules: { isError: false },
            check_cashback_timeout_minutes_rules: { isError: false }
        });
    };
    EventBindingOnTimerCfgEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if (this.state.is_only_create_on_exact_day_of_month_number) {
            if ((this.state.only_create_on_exact_day_of_month_number < 1) || (this.state.only_create_on_exact_day_of_month_number > 31)) {
                this.setState({
                    only_create_on_exact_day_of_month_number_rules: { isError: true, errorMessage: "Поле [Число месяца] заполнено некорректно!" },
                });
                return false;
            }
        }
        if (this.state.is_only_create_on_exact_day_of_week_number) {
            if ((this.state.only_create_on_exact_day_of_week_number < 1) || (this.state.only_create_on_exact_day_of_week_number > 7)) {
                this.setState({
                    only_create_on_exact_day_of_week_number_rules: { isError: true, errorMessage: "Поле [День недели] заполнено некорректно!" }
                });
                return false;
            }
        }
        if ((this.state.create_on_exact_hour_of_day_number < 0) || (this.state.create_on_exact_hour_of_day_number > 23)) {
            this.setState({
                create_on_exact_hour_of_day_number_rules: { isError: true, errorMessage: "Поле [Час дня] заполнено некорректно!" }
            });
            return false;
        }
        if (this.state.check_cashback_timeout_minutes <= 0) {
            this.setState({
                check_cashback_timeout_minutes_rules: { isError: true, errorMessage: "Поле [таймаут, минут] заполнено некорректно!" }
            });
            return false;
        }
        return true;
    };
    EventBindingOnTimerCfgEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                event_binding_id: this.props.record.key,
                is_only_create_on_exact_day_of_month_number: this.state.is_only_create_on_exact_day_of_month_number,
                only_create_on_exact_day_of_month_number: this.state.only_create_on_exact_day_of_month_number,
                is_only_create_on_exact_day_of_week_number: this.state.is_only_create_on_exact_day_of_week_number,
                only_create_on_exact_day_of_week_number: this.state.only_create_on_exact_day_of_week_number,
                is_only_create_on_exact_hour_of_day_number: this.state.is_only_create_on_exact_hour_of_day_number,
                create_on_exact_hour_of_day_number: this.state.create_on_exact_hour_of_day_number,
                check_cashback_timeout_minutes: this.state.check_cashback_timeout_minutes
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Настройки обработичка события <кэшбэк> изменены!");
            });
        }
    };
    EventBindingOnTimerCfgEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    EventBindingOnTimerCfgEditor.prototype.getFormTitle = function () {
        return "Изменить настройки обработчика события <кэшбэк>";
    };
    EventBindingOnTimerCfgEditor.prototype.getActionButtons = function () {
        return (React.createElement(CardRowButtonSet_1.default, { editMode: true, title: { btnEdit: "Сохранить", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }));
    };
    EventBindingOnTimerCfgEditor.prototype.getContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Создавать бонус только в указанное число месяца", value: this.state.is_only_create_on_exact_day_of_month_number, onChecked: function (checked) {
                    _this.setState({
                        is_only_create_on_exact_day_of_month_number: checked
                    });
                } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Число месяца(1-31):", placeholder: "Введите значение числа месяца" }, values: { max: 31, min: 1, value: this.state.only_create_on_exact_day_of_month_number }, onValueChanged: function (newVal) {
                    _this.setState({
                        only_create_on_exact_day_of_month_number: newVal,
                        only_create_on_exact_day_of_month_number_rules: { isError: false }
                    });
                }, disabled: !this.state.is_only_create_on_exact_day_of_month_number, rules: this.state.only_create_on_exact_day_of_month_number_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Создавать бонус только в указанный день недели", value: this.state.is_only_create_on_exact_day_of_week_number, onChecked: function (checked) {
                    _this.setState({
                        is_only_create_on_exact_day_of_week_number: checked
                    });
                } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "День недели(1-7):", placeholder: "Введите значение дня недели" }, values: { max: 7, min: 0, value: this.state.only_create_on_exact_day_of_week_number }, onValueChanged: function (newVal) {
                    _this.setState({
                        only_create_on_exact_day_of_week_number: newVal,
                        only_create_on_exact_day_of_week_number_rules: { isError: false }
                    });
                }, disabled: !this.state.is_only_create_on_exact_day_of_week_number, rules: this.state.only_create_on_exact_day_of_week_number_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Создавать бонус только в указанный час суток", value: this.state.is_only_create_on_exact_hour_of_day_number, onChecked: function (checked) {
                    _this.setState({
                        is_only_create_on_exact_hour_of_day_number: checked
                    });
                } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Час суток(0-23):", placeholder: "Введите значение часа суток" }, values: { max: 23, min: 0, value: this.state.create_on_exact_hour_of_day_number }, onValueChanged: function (newVal) {
                    _this.setState({
                        create_on_exact_hour_of_day_number: newVal,
                        create_on_exact_hour_of_day_number_rules: { isError: false }
                    });
                }, disabled: !this.state.is_only_create_on_exact_hour_of_day_number, rules: this.state.create_on_exact_hour_of_day_number_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Интервал проверки, минут:", placeholder: "Введите значение интервала проверки в минутах" }, values: { max: 99999, min: 1, value: this.state.check_cashback_timeout_minutes }, onValueChanged: function (newVal) {
                    _this.setState({
                        check_cashback_timeout_minutes: newVal,
                        check_cashback_timeout_minutes_rules: { isError: false }
                    });
                }, rules: this.state.check_cashback_timeout_minutes_rules }),
            this.getActionButtons()));
    };
    EventBindingOnTimerCfgEditor.prototype.render = function () {
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 500 }, this.getContent()));
    };
    return EventBindingOnTimerCfgEditor;
}(React.Component));
exports.default = EventBindingOnTimerCfgEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_events_bindings/ui/component/event_config/on_cashback/EventBindingOnCashBackCfgEditor.tsx
// module id = 1984
// module chunks = 0